// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"a53813db","453":"7f90d79b","455":"5e454bc3"}[chunkId] + ".chunk.js";
};